var React = require('react');

function ArrowWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M25.1408 19.7798L10.5977 19.7798V18.3669L25.1408 18.3669L20.6951 13.9212L21.6941 12.9221L27.8454 19.0734L21.6941 25.2246L20.6951 24.2255L25.1408 19.7798Z","fill":"white","stroke":"white"}));
}

ArrowWhite.defaultProps = {"width":"39","height":"39","viewBox":"0 0 39 39","fill":"none"};

module.exports = ArrowWhite;

ArrowWhite.default = ArrowWhite;
